export default __webpack_public_path__ + "static/GrandMoffTarkin-4816a6b176a9fd89fba240856d894af1.jpeg";